import { render, staticRenderFns } from "./WorldMap.vue?vue&type=template&id=52c89c6b&scoped=true"
import script from "./WorldMap.vue?vue&type=script&lang=js"
export * from "./WorldMap.vue?vue&type=script&lang=js"
import style0 from "./WorldMap.vue?vue&type=style&index=0&id=52c89c6b&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52c89c6b",
  null
  
)

export default component.exports